import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { TNewsListingItem } from '../../types/newsListing.types';
import NewsCard from '../newsCard';
import AnalyticsVisibleEvent from '../../../@shared/analyticsVisibleEvent';
import { TSocialMediaBarProps } from '../../../@shared/socialMediaBar/types/socialMediaBar.types';

const NewsCardList: FC<{ items: TNewsListingItem[]; rendering?: ComponentRendering; socialMediaBarProps?: TSocialMediaBarProps; }> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul className="news-listing__card-list">
      {props.items.map((item, index) => {
        return (
          <li className="news-listing__card" key={`${item?.id}`}>
            <AnalyticsVisibleEvent className="news-listing__card-wrapper" rendering={props.rendering} title={item.title} template={'News Listing'}>
              <NewsCard {...item} index={index} socialMediaBarProps={props.socialMediaBarProps}/>
            </AnalyticsVisibleEvent>
          </li>
        );
      })}
    </ul>
  );
};

export default NewsCardList;
